import React, { useEffect, useState } from 'react';
import { sitePolicy } from '../asiosConfig';
import { toast } from 'react-toastify';
import { Box, Container, Paper, Skeleton, Typography } from '@mui/material';
import Nav from './Nav';
import Footer from './Footer';
import testimonyImg from "../images/testimonyImg.png";


export const AboutUs = () => {
    const [aboutUs, setAboutUs] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAboutUs = async () => {
            try {
                const response = await sitePolicy();
                if (response.status === 200 || response.status === 201) {
                    setAboutUs(response.data.data);
                } else {
                    toast.error('Failed to fetch about us data');
                }
            } catch (error) {
                toast.error('Failed to fetch about us data');
            } finally {
                setLoading(false);
            }
        };
        fetchAboutUs();
    }, []);

    return (
        <Box>
            <Nav />
            <Box mt={12}>
                <Container maxWidth={false} sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
                    <Paper elevation={4} sx={{ p: 4, mb: 6, width: '80%', mx: 'auto' }}>
                        <Box textAlign="center" mb={12} mt={5}>
                            {loading ? (
                                <>
                                    {/* Skeleton for Title */}
                                    <Skeleton variant="text" width="60%" height={40} sx={{ mx: 'auto', mb: 3 }} />

                                    {/* Skeleton for Description */}
                                    <Skeleton variant="rectangular" height={100} width="100%" sx={{ mb: 4 }} />

                                    {/* Skeletons for Testimony Images */}
                                    <Box display="flex" justifyContent="center" gap={2} flexWrap="wrap" mt={4}>
                                        {[...Array(4)].map((_, index) => (
                                            <Skeleton
                                                key={index}
                                                variant="rectangular"
                                                width={150}
                                                height={150}
                                                sx={{ borderRadius: 1 }}
                                            />
                                        ))}
                                    </Box>
                                </>
                            ) : (
                                <>
                                    <Typography
                                        variant="h4"
                                        component="h3"
                                        gutterBottom
                                        sx={{ fontFamily: "Montserrat" }}
                                    >
                                        IND Matrimony About Us
                                    </Typography>

                                    <div className='text-left' dangerouslySetInnerHTML={{ __html: aboutUs.about_us }} />
                                    {/* <div className="row d-flex justify-content-center align-items-center mt-4">
                                        <div className="col-md-3">
                                            <img src={testimonyImg} className="img-fluid mt-2" />
                                        </div>
                                        <div className="col-md-3">
                                            <img src={testimonyImg} className="img-fluid mt-2" />
                                        </div>
                                        <div className="col-md-3">
                                            <img src={testimonyImg} className="img-fluid mt-2" />
                                        </div>
                                        <div className="col-md-3">
                                            <img src={testimonyImg} className="img-fluid mt-2" />
                                        </div>
                                    </div> */}
                                </>
                            )}
                        </Box>
                    </Paper>
                </Container>
            </Box>
            <Footer />
        </Box>
    );
};
